export default __webpack_public_path__ + "static/aria-945224_1920-53979277e9aea24f35e76900c13d8c19.png";